// A case in one of these statuses is closed: its analysis is never advanced
// again by the engine sweep or the dashboard's driver (hotfix 14/10/2026,
// production: an archived test case was offered to the sweep every minute for
// days). An officer who reopens a case starts a new run with Reprocess.
export const CLOSED_CASE_STATUSES = ['archived', 'declined', 'jaybee_declined', 'withdrawn', 'rejected'];
export const isClosedCase = (status) => CLOSED_CASE_STATUSES.includes(String(status || ''));
